(() => {
  "use strict";

  const SELECTOR = "[data-jv-header]";

  function initHeader(root) {
    if (!root || root.dataset.jvInitialized === "true") return;

    root.dataset.jvInitialized = "true";

    const body = document.body;

    const drawer = root.querySelector("[data-jv-mobile-drawer]");
    const drawerOpenButtons = root.querySelectorAll("[data-jv-drawer-open]");
    const drawerCloseButtons = root.querySelectorAll("[data-jv-drawer-close]");

    const searchModal = root.querySelector("[data-jv-search-modal]");
    const searchOpenButtons = root.querySelectorAll("[data-jv-search-open]");
    const searchCloseButtons = root.querySelectorAll("[data-jv-search-close]");
    const searchInput = root.querySelector("[data-jv-search-input]");

    const submenuButtons = root.querySelectorAll(
      "[data-jv-submenu-button]"
    );

    let lastFocusedElement = null;

    const updateBodyLock = () => {
      const shouldLock =
        root.classList.contains("jv-mobile-open") ||
        root.classList.contains("jv-search-open");

      body.classList.toggle("jv-header-lock", shouldLock);
    };

    const closeDesktopMenus = (exceptItem = null) => {
      root.querySelectorAll(".jv-nav__item.is-open").forEach((item) => {
        if (item === exceptItem) return;

        item.classList.remove("is-open");

        const button = item.querySelector("[data-jv-submenu-button]");
        if (button) button.setAttribute("aria-expanded", "false");
      });
    };

    const openDrawer = (trigger) => {
      if (!drawer) return;

      lastFocusedElement = trigger || document.activeElement;

      root.classList.remove("jv-search-open");
      root.classList.add("jv-mobile-open");

      drawer.setAttribute("aria-hidden", "false");
      if (searchModal) searchModal.setAttribute("aria-hidden", "true");

      updateBodyLock();

      const closeButton = drawer.querySelector("[data-jv-drawer-close]");
      window.setTimeout(() => closeButton?.focus(), 80);
    };

    const closeDrawer = (restoreFocus = true) => {
      if (!drawer) return;

      root.classList.remove("jv-mobile-open");
      drawer.setAttribute("aria-hidden", "true");

      updateBodyLock();

      if (restoreFocus && lastFocusedElement) {
        window.setTimeout(() => lastFocusedElement.focus(), 80);
      }
    };

    const openSearch = (trigger) => {
      if (!searchModal) return;

      lastFocusedElement = trigger || document.activeElement;

      root.classList.remove("jv-mobile-open");
      root.classList.add("jv-search-open");

      searchModal.setAttribute("aria-hidden", "false");
      if (drawer) drawer.setAttribute("aria-hidden", "true");

      updateBodyLock();

      window.setTimeout(() => searchInput?.focus(), 100);
    };

    const closeSearch = (restoreFocus = true) => {
      if (!searchModal) return;

      root.classList.remove("jv-search-open");
      searchModal.setAttribute("aria-hidden", "true");

      updateBodyLock();

      if (restoreFocus && lastFocusedElement) {
        window.setTimeout(() => lastFocusedElement.focus(), 80);
      }
    };

    drawerOpenButtons.forEach((button) => {
      button.addEventListener("click", () => openDrawer(button));
    });

    drawerCloseButtons.forEach((button) => {
      button.addEventListener("click", () => closeDrawer());
    });

    searchOpenButtons.forEach((button) => {
      button.addEventListener("click", () => openSearch(button));
    });

    searchCloseButtons.forEach((button) => {
      button.addEventListener("click", () => closeSearch());
    });

    submenuButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const item = button.closest(".jv-nav__item");
        if (!item) return;

        const willOpen = !item.classList.contains("is-open");

        closeDesktopMenus(item);
        item.classList.toggle("is-open", willOpen);
        button.setAttribute("aria-expanded", String(willOpen));
      });
    });

    document.addEventListener("click", (event) => {
      if (!root.contains(event.target)) {
        closeDesktopMenus();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;

      if (root.classList.contains("jv-search-open")) {
        closeSearch();
        return;
      }

      if (root.classList.contains("jv-mobile-open")) {
        closeDrawer();
        return;
      }

      closeDesktopMenus();
    });

    window.addEventListener(
      "scroll",
      () => {
        if (root.dataset.sticky !== "true") return;
        root.classList.toggle("is-scrolled", window.scrollY > 12);
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      if (window.innerWidth > 989) {
        closeDrawer(false);
      }
    });

    root.addEventListener("click", (event) => {
      const clickedInsideMenu = event.target.closest(".jv-nav__item");

      if (!clickedInsideMenu && !event.target.closest("[data-jv-search-open]")) {
        closeDesktopMenus();
      }
    });
  }

  function initializeAllHeaders(container = document) {
    container.querySelectorAll(SELECTOR).forEach(initHeader);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeAllHeaders();
    });
  } else {
    initializeAllHeaders();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAllHeaders(event.target);
  });

  document.addEventListener("shopify:section:unload", () => {
    document.body.classList.remove("jv-header-lock");
  });
})();